export const FLYER_TYPE_PREVIEW = 'preview';
export const FLYER_TYPE_IEP = 'IEP';
export const FLYER_TYPE_GROAN_OPENING = 'Grand Opening';
export const FLYER_TYPE_DOLLAR_RUSH = 'Dollar Rush';
export const FLYER_TYPE_OTHER_PUBLICATIONS_RESPONSIVE = 'Other Publications - Responsive';
export const FLYER_TYPE_OTHER_PUBLICATIONS_STATIC = 'Other Publications - Static';
export const FLYER_TYPE_WEEKLY_FLYER = 'Weekly Flyer';
